import WithRender from "../../templates/layouts/layoutStockDefaultPdfConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCimpressNoQuantity"])
  }
});
